import { Injectable, TemplateRef, ViewContainerRef } from '@angular/core';
import { TemplatePortal, CdkPortalOutlet } from '@angular/cdk/portal';

@Injectable({ providedIn: 'root' })
export class FooterPortalService {
  private portalOutlet: CdkPortalOutlet | null = null;

  setOutlet(outlet: CdkPortalOutlet) {
    this.portalOutlet = outlet;
  }

  showTemplate(template: TemplateRef<any>, viewContainer: ViewContainerRef) {
    if (this.portalOutlet) {
      const templatePortal = new TemplatePortal(template, viewContainer);
      this.portalOutlet.attach(templatePortal);
    }
  }

  hideTemplate() {
    if (this.portalOutlet && this.portalOutlet.hasAttached()) {
      this.portalOutlet.detach();
    }
  }
}